import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.CreateStatementFromContracts.IRequest;
type Response = Api.Core.Contract.CreateStatementFromContracts.IResponse;
type Headers = Api.Core.Contract.CreateStatementFromContracts.IHeaders;
const url = '/api/DealerManagement/Statement/FromContracts';
export default async function createStatementsFromContractListApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
